import { authService } from './auth-service';

export interface KbCategoryStats {
  count: number;
  prevMonthCount: number;
}

export interface DashboardKbStats {
  global: KbCategoryStats;
  project: KbCategoryStats;
  procurement: KbCategoryStats;
  // NOTE-043: funding KBs are counted under their own category for the funding variant.
  funding?: KbCategoryStats;
}

/**
 * View KB stats as a map keyed by category id, for rendering one card per
 * `instanceConfig.kbCategories` entry (the keys are a known closed set, but the
 * variant decides which subset to show). Returns an empty map for null stats.
 */
export const kbStatsByCategory = (
  stats: DashboardKbStats | null | undefined,
): Record<string, KbCategoryStats | undefined> =>
  (stats ?? {}) as Record<string, KbCategoryStats | undefined>;

export interface MonthlyDataPoint {
  month: string;
  yearMonth?: string;
  docsValidated: number;
  kbCreated: number;
  responsesEvaluated: number;
}

export interface DashboardStats {
  kbStats: DashboardKbStats;
  userCount: number;
  usagePercent: number;
  monthlyLimit: number;
  monthlyData: MonthlyDataPoint[];
  cachedAt: string;
}

class DashboardService {
  async getStats(): Promise<DashboardStats> {
    return authService.makeAuthenticatedRequest<DashboardStats>('/api/dashboard/stats');
  }
}

export const dashboardService = new DashboardService();
